import { useTranslation } from '../i18n';
import React from 'react';
import { Card, Progress, List, Tag, Typography, Space, Button, Empty } from 'antd';
import {
    LoadingOutlined, CheckCircleOutlined, CloseCircleOutlined,
    CompressOutlined, FileZipOutlined, CloudDownloadOutlined,
    DeleteOutlined
} from '@ant-design/icons';

const { Text } = Typography;

/**
 * 任务进度显示组件
 * 显示异步任务的进度和状态
 */
const TaskProgress = ({ tasks, onClearCompleted, style }) => {
    const { t } = useTranslation();
    if (!tasks || tasks.length === 0) {
        return null;
    }

    const getTaskIcon = (type) => {
        switch (type) {
            case 'compress':
                return <CompressOutlined />;
            case 'extract':
                return <FileZipOutlined />;
            case 'download':
                return <CloudDownloadOutlined />;
            default:
                return <LoadingOutlined />;
        }
    };

    const getStatusTag = (status) => {
        switch (status) {
            case 'pending':
                return <Tag color="default">{t('Waiting')}</Tag>;
            case 'running':
            case 'in_progress':
                return <Tag color="processing" icon={<LoadingOutlined spin />}>{t('In progress')}</Tag>;
            case 'completed':
                return <Tag color="success" icon={<CheckCircleOutlined />}>{t('Done')}</Tag>;
            case 'failed':
                return <Tag color="error" icon={<CloseCircleOutlined />}>{t('Failed')}</Tag>;
            default:
                return <Tag>{status}</Tag>;
        }
    };

    const getProgressStatus = (status) => {
        switch (status) {
            case 'completed':
                return 'success';
            case 'failed':
                return 'exception';
            default:
                return 'active';
        }
    };

    const hasCompletedTasks = tasks.some(t => t.status === 'completed' || t.status === 'failed');

    return (
        <Card
            size="small"
            title={
                <Space>
                    <LoadingOutlined spin={tasks.some(t => t.status === 'running' || t.status === 'in_progress' || t.status === 'pending')} />
                    <span>{t('Background tasks')}</span>
                    <Tag>{tasks.length}</Tag>
                </Space>
            }
            extra={
                hasCompletedTasks && (
                    <Button
                        type="link"
                        size="small"
                        icon={<DeleteOutlined />}
                        onClick={onClearCompleted}
                    >
                        {t('Purge complete')}
                    </Button>
                )
            }
            style={{ marginBottom: 16, ...style }}
        >
            <List
                size="small"
                dataSource={tasks}
                renderItem={(task) => (
                    <List.Item key={task.id}>
                        <List.Item.Meta
                            avatar={getTaskIcon(task.type)}
                            title={
                                <Space>
                                    <Text ellipsis style={{ maxWidth: 200 }}>{task.description}</Text>
                                    {getStatusTag(task.status)}
                                </Space>
                            }
                            description={
                                <div>
                                    <Progress
                                        percent={task.progress}
                                        size="small"
                                        status={getProgressStatus(task.status)}
                                        format={percent => `${percent}%`}
                                    />
                                    {task.message && (
                                        <Text type="secondary" style={{ fontSize: 12 }}>
                                            {task.message}
                                        </Text>
                                    )}
                                </div>
                            }
                        />
                    </List.Item>
                )}
            />
        </Card>
    );
};

export default TaskProgress;
